export default {
    calculateRoundedTimestamp(videoPosition) {
        if (typeof videoPosition === 'number' && !isNaN(videoPosition)) {
            return Math.floor(DMUtils.round(videoPosition, 2));
        }
    },
    calculateDisplayTimestamp(videoPosition) {
        if (typeof videoPosition === 'number' && !isNaN(videoPosition)) {
            let roundedTimestamp = Math.floor(DMUtils.round(videoPosition, 2));
            return new Date(roundedTimestamp * 1000).toISOString().slice(11, 19);
        }
    }
};
